























































































































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import LogoSelector from '@ui/LogoSelector'
import RequestButton from '@/components/RequestButton'
import ImpersonateMenu from '@/components/ImpersonateMenu'

settings =
  name: "Onboarding"
  resources:
    onboardingWizard: 
      resourceName: "onboarding_wizard"
      slug: "onboarding_wizards/:member.token/edit"
  vue:
    components: {
      LogoSelector,
      RequestButton,
      ImpersonateMenu,
    }

    store: ['member']
    data: ->
      isUniversity: null
      selectedUniversityId: null
      selectedSubOrgId: null
      selectedNewSubOrg: false
      universityQuery: null
      universities: []
      plansToTransition: false
      form:
        wait_listed: false
        university:
          id: null
        organizer:
          first_name: null
          last_name: null
          phone: null
          role: null
        org:
          name: null
          domain: null
          logo: null
        sub_organization:
          id: null
          organization_name: null

    computed:
      hasIndicatedSuborg: ->  return @form.sub_organization.name or @selectedSubOrgId?
      isAdvisor: ->  return @form.organizer.role is 'advisor'
      isStudent: ->  return @form.organizer.role is 'student'
      notWithUniversity: -> @isUniversity? and not @isUniversity
      formIsValid: -> @form.organizer.first_name and (@form.org.name or @form.university.id)
      formIsNotValid: -> not @formIsValid
      guessMemberDomain: -> @member.email.split('@')[1]

    methods:
      hasSuborgs: -> @prime.options.sub_organizations?.length
      saveWizard: ->
        @form.sub_organization.name = null if @selectedSubOrgId?
        if !@form.sub_organization.name? and @isUniversity and !@selectedSubOrgId?
          return @showAlert('Please enter the name of your organization.', 'Validation Alert') 
        @prime.onboardingWizard[field] = data for field, data of @form
        @saveItem 'onboardingWizard', @prime.onboardingWizard
      fetchSubOrgs: ->
        @fetch 'onboardingWizard', { university_id: @selectedUniversityId }
      searchUniversity: (query) ->
        @universities = await RecessAPI.search 'universities', { text: query }
      onSave: (item)->
        @setCurrentMember(item)
        @navigateToDashboard()
      plansToTransitionChanged: -> @form.organizer.transfer_account_at = null if @plansToTransition is false
      subOrgIsSelected: (org)->
        @selectedSubOrgId is org.id
      toggleSelectedSubOrg:(org)->
        if not org? # entering a new sub org
          @$refs.otherOrg?.focus()
          @selectedNewSubOrg = true
          @selectedSubOrgId = null
          @form.sub_organization.id = null
          return
        # else selected an existing sub org
        @selectedNewSubOrg = false
        @selectedSubOrgId = org.id

      hiSelectOrgLogo: (brand) ->
        @form.org.logo = brand.logo
        @form.org.domain = brand.domain
        @form.org.name = brand.name
      hiSelectSubOrgLogo: (brand) ->
        @form.sub_organization.logo = brand.logo
        @form.sub_organization.domain = brand.domain
        @form.sub_organization.name = brand.name

    watch:
      # isUniversity: (isuni)->
      #   @form.wait_listed = not isuni

      selectedUniversityId: (uni) ->
        @form.university.id = uni
        @selectedSubOrgId = null
        @form.sub_organization.id = null
        @selectedNewSubOrg = false
        @fetchSubOrgs()
      selectedSubOrgId: (id)->
        @form.sub_organization.id = id
        # @form.sub_organization.name = null if id?

    updated: ->
      return unless @prime.onboardingWizard?
      @form.organizer.first_name ||= @prime.onboardingWizard.organizer.first_name
      @form.organizer.last_name ||= @prime.onboardingWizard.organizer.last_name

export default VueOptions.vue settings
